module.exports = __webpack_public_path__ + "img/microsoft.ab74ce37.svg";